import { BaseService } from './base.service';
import { RolePrivilegeDto, CreateRolePrivilegeDto, UpdateRolePrivilegeDto } from '../types/dtos/role-privilege.dto';
import { ENDPOINTS } from '../endpoints';
import { CustomResponseEntity } from '../types/common';

export class RolePrivilegeService extends BaseService<RolePrivilegeDto, CreateRolePrivilegeDto, UpdateRolePrivilegeDto> {
  constructor() {
    super(ENDPOINTS.rolePrivileges.base());
  }

  async findByRoleId(roleId: string): Promise<CustomResponseEntity<RolePrivilegeDto[]>> {
    return this.get(`/${roleId}`);
  }
}

export const rolePrivilegeService = new RolePrivilegeService();
